import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMuteVolume = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "currentColor",
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.3502 7.58132C17.067 7.05811 18.0169 6.97776 18.8122 7.3753C19.6169 7.77775 20.1252 8.60036 20.125 9.5C20.125 9.50008 20.125 9.49993 20.125 9.5V22.5C20.125 23.3996 19.6167 24.222 18.8121 24.6243C18.0169 25.0219 17.0671 24.9417 16.3503 24.4187L9.4066 20H6.375C5.06332 20 4 18.9367 4 17.625V14.375C4 13.0633 5.06332 12 6.375 12H9.4066L16.3502 7.58132ZM18.1414 8.71694C17.845 8.56884 17.4902 8.60094 17.2252 8.79987C17.2098 8.81143 17.1939 8.8224 17.1777 8.83275L10.0277 13.3827C9.90732 13.4593 9.76764 13.5 9.625 13.5H6.375C5.89175 13.5 5.5 13.8918 5.5 14.375V17.625C5.5 18.1083 5.89175 18.5 6.375 18.5H9.625C9.76764 18.5 9.90732 18.5407 10.0277 18.6173L17.1777 23.1673C17.1939 23.1776 17.2096 23.1885 17.225 23.2C17.4901 23.3989 17.8449 23.4308 18.1413 23.2826C18.4377 23.1344 18.625 22.8314 18.625 22.5V9.5C18.6251 9.16859 18.4378 8.86526 18.1414 8.71694Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.625 12C10.0392 12 10.375 12.3358 10.375 12.75V19.25C10.375 19.6642 10.0392 20 9.625 20C9.21079 20 8.875 19.6642 8.875 19.25V12.75C8.875 12.3358 9.21079 12 9.625 12Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M29.6531 12.6259C29.946 12.9188 29.946 13.3937 29.6531 13.6866L23.9656 19.3741C23.6727 19.667 23.1979 19.667 22.905 19.3741C22.6121 19.0812 22.6121 18.6063 22.905 18.3134L28.5925 12.6259C28.8854 12.333 29.3602 12.333 29.6531 12.6259Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M22.905 12.6259C23.1979 12.333 23.6727 12.333 23.9656 12.6259L29.6531 18.3134C29.946 18.6063 29.946 19.0812 29.6531 19.3741C29.3602 19.667 28.8854 19.667 28.5925 19.3741L22.905 13.6866C22.6121 13.3937 22.6121 12.9188 22.905 12.6259Z"
		})
	]
});
export { SvgMuteVolume as ReactComponent };
